export const LANGUAGE_CONFIG = [
    {
        langName: 'English',
        langCode: 'en',
        translation: 'English',
        isActive: true
    },
    {
        langName: 'Hindi',
        langCode: 'hi',
        translation: 'हिंदी (Hindi)',
        isActive: true
    },
    {
        langName: 'Tamil',
        langCode: 'ta',
        translation: 'தமிழ் (Tamil)',
        isActive: true
    },
    {
        langName: 'Urdu',
        langCode: 'ur',
        translation: 'اردو (Urdu)',
        isActive: true
    },
    {
        langName: 'Kannada',
        langCode: 'kn',
        translation: 'ಕನ್ನಡ (Kannada)',
        isActive: true
    },
    {
        langName: 'Marathi',
        langCode: 'mr',
        translation: 'मराठी (Marathi)',
        isActive: true
    },
    {
        langName: 'Punjabi',
        langCode: 'pa',
        translation: 'ਪੰਜਾਬੀ (Punjabi)',
        isActive: true
    },
    {
        langName: 'Bengali',
        langCode: 'bn',
        translation: 'বাংলা (Bengali)',
        isActive: true
    },
    {
        langName: 'Telugu',
        langCode: 'te',
        translation: 'తెలుగు (Telugu)',
        isActive: true
    },
    {
        langName: 'Sindhi',
        langCode: 'sd',
        translation: 'سنڌي (Sindhi)',
        isActive: true
    },
    {
        langName: 'Gujarati',
        langCode: 'gu',
        translation: 'ગુજરાતી (Gujarati)',
        isActive: true
    },
    {
        langName: 'Sanskrit',
        langCode: 'sa',
        translation: 'संस्कृतम् (Sanskrit)',
        isActive: true
    },
    {
        langName: 'Odia',
        langCode: 'or',
        translation: 'ଓଡିଆ (Odia)',
        isActive: true
    },
    {
        langName: 'Assamese',
        langCode: 'as',
        translation: 'অসমীয়া (Assamese)',
        isActive: true
    },
    {
        langName: 'Bhojpuri',
        langCode: 'bho',
        translation: 'भोजपुरी (Bhojpuri)',
        isActive: true
    },
    {
        langName: 'Awadhi',
        langCode: 'awa',
        translation: 'अवधी (Awadhi)',
        isActive: true
    },
    {
        langName: 'Malayalam',
        langCode: 'ml',
        translation: 'മലയാളം (Malayalam)',
        isActive: true
    },
    // {
    //     langName: 'Santali',
    //     langCode: 'sat',
    //     translation: 'ᱥᱚᱱᱛᱟᱞᱤ (Santali)',
    //     isActive: true
    // },
    // {
    //     langName: 'Nishi',
    //     langCode: 'njz',
    //     translation: 'Nishi (Nishi)',
    //     isActive: true
    // },
    // {
    //     langName: 'Lushai',
    //     langCode: 'lus',
    //     translation: 'लुशाई (Lushai)',
    //     isActive: true
    // },
    {
        langName: 'Nepali',
        langCode: 'ne',
        translation: 'नेपाली (Nepali)',
        isActive: true
    },
    // {
    //     langName: 'Dogri',
    //     langCode: 'doi',
    //     translation: 'डोगरी (Dogri)',
    //     isActive: true
    // },
    // {
    //     langName: 'Magahi',
    //     langCode: 'mag',
    //     translation: 'मगाही (Magahi)',
    //     isActive: true
    // },
    // {
    //     langName: 'Bodo',
    //     langCode: 'brx',
    //     translation: 'बड (Bodo)',
    //     isActive: true
    // },
    // {
    //     langName: 'Gujrati',
    //     langCode: 'gu',
    //     translation: 'ગુજરાતી (Gujrati)',
    //     isActive: true
    // },
    // {
    //     langName: 'Rajasthani',
    //     langCode: 'raj',
    //     translation: 'Rajasthani (Rajasthani)',
    //     isActive: true
    // },
    // {
    //     langName: 'Sanskrit',
    //     langCode: 'sa',
    //     translation: 'संस्कृतं (Sanskrit)',
    //     isActive: true
    // },
    // {
    //     langName: 'Kashmiri',
    //     langCode: 'ks',
    //     translation: 'کشمیری۔ (Kashmiri)',
    //     isActive: true
    // },
    // {
    //     langName: 'Panim',
    //     langCode: 'pnr',
    //     translation: 'Panim (Panim)',
    //     isActive: true
    // },
    // {
    //     langName: 'Konkani',
    //     langCode: 'kok',
    //     translation: 'Konkani (Konkani)',
    //     isActive: true
    // }
    ];